<template>
    <div>
        <b-row>

            <b-col sm=12>
                <h5 
                    class="heading-1 mb-4 text-primary"
                    v-if="subTitulo != null"
                >    
                    <span>{{ subTitulo }}</span>
                </h5>
                <app-tabela
                    idTabela="tblDespesas"
                    :itens="despesas"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="projetoEtapa" slot-scope="data">
                        <span
                            >Código:
                            <strong>{{ data.codProjeto }}</strong></span
                        ><br />
                        <span
                            >Projeto: <strong>{{ data.projeto }}</strong></span
                        ><br />
                        <span
                            >Etapa: <strong>{{ data.idEtapa }}</strong></span
                        ><br />
                    </template>
                    <template slot="botoes">
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="status" slot-scope="data">
                        <app-status
                            :status="data.status.toUpperCase()"
                        ></app-status>
                    </template>
                    <template slot="valorDespesa" slot-scope="data">{{
                        data.valorDespesa | currency
                    }}</template>
                    <template slot="dataExecucaoDespesa" slot-scope="data">{{
                        $moment(data.dataExecucaoDespesa).format('DD/MM/YYYY')
                    }}</template>
                    <template slot="idMov" slot-scope="data">
                        {{ data.idMov }}
                        <status-id-mov :despesa="data"></status-id-mov>
                        <btn-erro-comprometimento
                            :despesa="data"
                            :servicos="servicos"
                            :permiteAcesso="
                                permiteAcessoErroComprometimento
                            "
                        ></btn-erro-comprometimento>
                        <BtnExcluirComprometimento
                            :despesa="data"
                            :servicos="servicos"
                            @recarregarDespesas="$emit('recarregarDespesas')"
                            :permiteExcluir="permiteExcluirComprometimento"
                        ></BtnExcluirComprometimento>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="despesaAcoes" v-bind="data"></slot>
                        <BtnAtualizarCentroCusto
                            :despesa="data"
                            :servicos="servicos"
                            :permiteAtualizarCentroCusto="permiteAtualizarCentroCusto"
                            @recarregarDespesas="$emit('recarregarDespesas')"
                        ></BtnAtualizarCentroCusto>
                    </template>
                    <template
                        slot="despesaSelecao"
                        slot-scope="data"
                        v-if="incluirSelecao"
                    >
                        <slot name="despesaSelecao" v-bind="data"></slot>
                    </template>
                </app-tabela>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import BtnAtualizarCentroCusto from './BtnAtualizarCentroCusto';
import BtnExcluirComprometimento from './BtnExcluirComprometimento';
import StatusIdMov from './StatusIdMov';
import BtnErroComprometimento from './BtnErroComprometimento';

export default {
    components: {
        BtnAtualizarCentroCusto,
        BtnExcluirComprometimento,
        StatusIdMov,
        BtnErroComprometimento
    },

    props: {
        subTitulo: {
            type: String,
            default: null
        },
        
        incluirSelecao: {
            type: Boolean,
            default: false
        },

        despesas: {
            type: Array,
            default: () => []
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        permiteAtualizarCentroCusto: {
           type: Boolean,
           default: false 
        },

        permiteExcluirComprometimento: {
           type: Boolean,
           default: false 
        }, 

        permiteAcessoErroComprometimento: {
            type: Boolean,
            default: false 
        }
    },
    
    data() {
        return {
            campos: [
                {
                    key: 'projetoEtapa',
                    label: 'Projeto/Etapa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataExecucaoDespesa',
                    label: 'Data de Execução',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valorDespesa',
                    label: 'Valor da Despesa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'idMov',
                    label: 'Comprometimento',
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10,
        }
    },

    created() {
        if (this.incluirSelecao) {
            this.campos.pop()
            this.campos.unshift({
                key: 'despesaSelecao',
                label: ''
            })
        }
    }
}
</script>